// Browsers only expose crypto.randomUUID in secure contexts (HTTPS or localhost). Manager is also opened over plain
// http on the LAN (http://<host-ip>:4173), where it is missing and the app rendered a blank page. getRandomValues
// is available in every context, so build an RFC 4122 v4 UUID from it.
if (globalThis.crypto && typeof globalThis.crypto.randomUUID !== 'function' && typeof globalThis.crypto.getRandomValues === 'function') {
  globalThis.crypto.randomUUID = function randomUUID() {
    const bytes = globalThis.crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  };
}

// Safari before 17.4 (iOS 17.3 and older) has no AbortSignal.any, and Safari before 16 has no AbortSignal.timeout.
// The customer quote/invoice and 3D-model pages use both, so without these they showed "Could not connect" for good.
if (typeof globalThis.AbortController === 'function' && typeof globalThis.AbortSignal === 'function') {
  if (typeof AbortSignal.timeout !== 'function') {
    AbortSignal.timeout = function timeout(ms) {
      const controller = new AbortController();
      setTimeout(() => controller.abort(typeof DOMException === 'function' ? new DOMException('The operation timed out.', 'TimeoutError') : undefined), ms);
      return controller.signal;
    };
  }
  if (typeof AbortSignal.any !== 'function') {
    AbortSignal.any = function any(signals) {
      const controller = new AbortController();
      const list = Array.from(signals || []);
      const already = list.find((signal) => signal.aborted);
      if (already) { controller.abort(already.reason); return controller.signal; }
      const onAbort = (event) => {
        list.forEach((signal) => signal.removeEventListener('abort', onAbort));
        controller.abort(event.target.reason);
      };
      list.forEach((signal) => signal.addEventListener('abort', onAbort));
      return controller.signal;
    };
  }
}
